import React, {Component} from "react";
import {Stack} from "@mui/material";
import {getAllRightBottomApps} from "./app_maker";
import ScaleBarOSD from "./rightBottom_apps/ScaleBarOSD";
import {connect} from "react-redux";
import {checkAppPermission} from "./utils/gammaScanUtils";
import {isAppHiddenForViewer, resolveActiveViewer} from "./openseadragon/viewerSelection";

class RightBottom extends Component {

	render() {
		return <Stack direction={"column"} spacing={0.5} alignItems={"flex-end"}>
			<Stack direction={"row-reverse"} spacing={0} alignItems={"flex-end"}>
				{getAllRightBottomApps()
					.filter(app => checkAppPermission(app) && !isAppHiddenForViewer(app, this.props.viewer))
					.map(app => app.component)}
			</Stack>
			<ScaleBarOSD/>
		</Stack>
	}
}

const mapStateToProps = (state) => {
	return {
		gammaState: state.gammaStateReducer,
		viewer: resolveActiveViewer(state),
	}
}

export default connect(mapStateToProps)(RightBottom);
